import * as React from 'react';

import { TextField , MaskedTextField} from 'office-ui-fabric-react/lib/TextField';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup} from 'office-ui-fabric-react/lib/ChoiceGroup';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { DatePicker } from 'office-ui-fabric-react/lib/DatePicker';

import { Config } from '../Config.js';
import { Mail } from './Mail.js';
import { Utils } from './Utils.js';
import { Session } from './Session.js';

const mail = new Mail();
const config = new Config();
const utils = new Utils();
const session = new Session();

const DayPickerStrings = config.getDayPickerStrings();
const firstDayOfWeek = config.getPrimoGiornoSettimana();
const maskAutolettura = config.getMaskAutolettura();
//const maskAutoletturaDecimal = config.getMaskAutoletturaDecimalPotenza();

export class DialogBox extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            modalIsOpen : false,
            hideDialog: true,
            title : '',
            testo : '',
            bottoni:'',
            elemento:props.elemento,
            tipo:props.tipo,
            campiDaLeggere : [],
            campiOriginali : {},
            
            tipoAzione : '',

            campoDaAggiornare : '',
            
            tipo_operazione : '',
            tipoAzioneInvio : '',
            
            mostraBottoniInvio : '',
            mostrasoloBottoneChiuso : 'nascosto',

            classErroreDeleteAccount : ''
        };
        
        this.showDialog = this.showDialog.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this._onChangeOption = this._onChangeOption.bind(this);
        this._onChangeCombo = this._onChangeCombo.bind(this);
        this._onSelectDate = this._onSelectDate.bind(this);
        this.creaOggettoDatiPost = this.creaOggettoDatiPost.bind(this);
        this.creaOggettoDatiPostAutolettura = this.creaOggettoDatiPostAutolettura.bind(this);
        
    }

    
    showDialog = () => {
        this.setState({ messaggio:'' , testo: this.getcontent() , hideDialog: false , modalIsOpen:true});
    };

    closeDialog = () => {
        this.setState({ hideDialog: true , modalIsOpen:false });
    };
    
    _onChangeOption( event ,option )
    {
        document.getElementById( option.id ).value = option.key;
    }

    _onChangeCombo( option , index, value )
    {
        document.getElementById( option.id ).value = option.key;
    }

    _onSelectDate ( date: Date | null | undefined ) {
        var datatxt = utils._onFormatDate( date );
        document.getElementById( this.state.campoDaAggiornare ).value = datatxt;
        // console.log(date, this.state.campoDaAggiornare);
    };

    
    inviaForm = () => {
        
        let datinuovi = {};
        
        for (let i in this.state.campiDaLeggere) {
            let key = this.state.campiDaLeggere[i];
            if( document.getElementById(key) !== null )
            {
                datinuovi[key] = document.getElementById(key).value;
            }
        }


        if( this.state.tipoAzioneInvio === 'autolettura' )
        {
            let objPostData = this.creaOggettoDatiPostAutolettura( datinuovi );
            
            this.setState({messaggio:'' , mostraBottoniInvio:'nascosto'});
            utils.inviaAutoletture( objPostData );
            this.gestisciRisultatoAutoletture( 0 );
        }
        
        if( this.state.tipoAzioneInvio === 'inviamail' )
        {
            let objPostData = this.creaOggettoDatiPost( datinuovi );

            mail.inviaMailHome( objPostData );
            this.gestisciRisultatoMail();
        }
        
        if( this.state.tipoAzioneInvio === 'privacy' )
        {
            let objPostData = this.creaOggettoDatiPost( datinuovi );
            
            this.setState({messaggio:''});
            utils.inviaPrivacy( objPostData );
            this.gestisciRisultatoPrivacy( 0 );
        }

        if( this.state.tipoAzioneInvio === 'eliminaaccount' )
        { 
            this.setState.classErroreDeleteAccount = ' qui ci provo';
            
            let request = new Request( config.get("customers_eliminaaccount") ,{
                method: 'POST',mode: 'cors', credentials: "include",
                body: JSON.stringify({id_cliente: session.get('id_cliente')})
            });

            fetch(request)
            .then(function(response){
                return response.json();
            })
            .then(function(result){
                if (result.success){

                    if( result.data.id_cliente === session.get('id_cliente') ){
                        utils.logout();
                        // this.closeDialog();
                    }
                    
                    this.setState.classErroreDeleteAccount = 'nascosto';
                } else {
                    this.setState({classErroreDeleteAccount: 'nascosto'});
                }
            }.bind(this) );

        }
        

        if( this.state.tipoAzioneInvio === 'cancellapassword' )
        { 
            this.setState.classErroreDeleteAccount = ' qui ci provo';
            
            let request = new Request( config.get("customers_cancellapassword") ,{
                method: 'POST',mode: 'cors', credentials: "include",
                body: JSON.stringify({id_cliente: session.get('id_cliente')})
            });

            fetch(request)
            .then(function(response){
                return response.json();
            })
            .then(function(result){
                if (result.success){

                    if( result.data.id_cliente === session.get('id_cliente') ){
                        utils.logout();
                        // this.closeDialog();
                    }
                    
                    this.setState.classErroreDeleteAccount = 'nascosto';
                } else {
                    this.setState({classErroreDeleteAccount: 'nascosto'});
                }
            }.bind(this) );

        }
    };
    
    creaOggettoDatiPostAutolettura(dn)
    {
        let obj = {};
        obj['id_cliente'] = session.get('id_cliente');
        obj['op'] = 'salva_autolettura';
        
        if( 'TILP' in dn){ 
            obj['TIPO']='E';
            obj['TILP']= dn.TILP ;
            
            obj['dataRif'] = dn.DATA_RIFERIMENTO;
            obj['dataRifPrec'] = utils.ottieniUltimoMesePrec( dn.DATA_RIFERIMENTO );
            
            obj['pod'] = dn.COD_STUMENTO;
            
            if( dn.TILP === 'M')
            {
                obj['attivaMono_att']= dn.eaf7 ;
                obj['reattivaMono_att']= dn.erf7 ;
                obj['potenzaMono_att']= dn.pf7 ;
            }
            
            //if( dn.TILP === 'F')  // http://10.11.2.51/issues/46619#note-9
            if( dn.TILP === 'F' || dn.TILP === 'O' || dn.TILP === 'ACEA')
            {
                obj['attivaF1_att']= dn.eaf1 ;
                obj['attivaF2_att']= dn.eaf2 ;
                obj['attivaF3_att']= dn.eaf3 ;
                
                obj['reattivaF1_att']= dn.erf1 ;
                obj['reattivaF2_att']= dn.erf2 ;
                obj['reattivaF3_att']= dn.erf3 ;
                
                obj['potenzaF1_att']= dn.pf1 ;
                obj['potenzaF2_att']= dn.pf2 ;
                obj['potenzaF3_att']= dn.pf3 ;
            }
        } 
        else 
        { 
            obj['TIPO']='G';
            obj['PDR']=dn.PDR;
            obj['REMI']=dn.REMI;
            obj['DATA_MISURA']=dn.DATA_RIFERIMENTO;
            obj['VAL_MISURA_CORRETTORE']=dn.MISURA_CORRETTORE;
            obj['VAL_MISURA_CONTATORE']=dn.LETTURA_ATTUALE;
        }
        
        return obj;
    }
    
    
    creaOggettoDatiPost( dn )
    {
        
        let dv = this.state.campiOriginali; 
        let dm = utils.estraiDatiModificati( dn , dv );
        
        // console.log('MODIICATI : ' ,dm);
        
        let obj = {};
        
        // per tutti passo id_cliente
        obj['id_cliente'] = session.get('id_cliente');
        obj['tipo_operazione'] = this.state.tipo_operazione;
        
        switch( this.state.tipo ) {
            case 'indirizzofatturaee':
            case 'indirizzofatturagas':
                if('COD_STUMENTO' in dm){ obj['COD_STUMENTO'] = dm.COD_STUMENTO; }
                if('INDIRIZZO_SPEDIZIONE' in dm){ obj['INDIRIZZO_SPEDIZIONE'] = dm.INDIRIZZO_SPEDIZIONE; }
                if('CIVICO_SPEDIZIONE' in dm){ obj['CIVICO_SPEDIZIONE'] = dm.CIVICO_SPEDIZIONE; }
                if('COMUNE_SPEDIZIONE' in dm){ obj['COMUNE_SPEDIZIONE'] = dm.COMUNE_SPEDIZIONE; }
                if('CAP_SPEDIZIONE' in dm){ obj['CAP_SPEDIZIONE'] = dm.CAP_SPEDIZIONE; }
                if('PROVINCIA_SPEDIZIONE' in dm){ obj['PROVINCIA_SPEDIZIONE'] = dm.PROVINCIA_SPEDIZIONE; }
                if('COMMENTI_SPEDIZIONE' in dm){ obj['COMMENTI_SPEDIZIONE'] = dm.COMMENTI_SPEDIZIONE; }
                if('operatore' in dm){ obj['NOME_OPERATORE'] = dm.operatore; }

                break;
            case 'sitoee':
            case 'sitogas':
                if('MATRICOLA_GRUPPO_MISURA' in dm){ obj['COD_STUMENTO'] = dm.MATRICOLA_GRUPPO_MISURA; }
                if('DES_SITO' in dm){ obj['DES_SITO'] = dm.DES_SITO; }
                if('INDIRIZZO_SITO' in dm){ obj['INDIRIZZO_SITO'] = dm.INDIRIZZO_SITO; }
                if('CAP_SITO' in dm){ obj['CAP_SITO'] = dm.CAP_SITO; }
                if('COMUNE_SITO' in dm){ obj['COMUNE_SITO'] = dm.COMUNE_SITO; }
                if('PROVINCIA_SITO' in dm){ obj['PROVINCIA_SITO'] = dm.PROVINCIA_SITO; }
                if('COMMENTI_SITO' in dm){ obj['COMMENTI_SITO'] = dm.COMMENTI_SITO; }
                if('operatore' in dm){ obj['NOME_OPERATORE'] = dm.operatore; }

                break;
            case 'anagraficautente':
                if('RAGIONE_SOCIALE' in dm){ obj['RAGIONE_SOCIALE'] = dm.RAGIONE_SOCIALE; }
                if('CODICE_FISCALE' in dm){ obj['CODICE_FISCALE'] = dm.CODICE_FISCALE; }
                if('PARTITA_IVA' in dm){ obj['PARTITA_IVA'] = dm.PARTITA_IVA; }
                if('CEL' in dm){ obj['CEL'] = dm.CEL; }
                if('EMAIL' in dm){ obj['EMAIL'] = dm.EMAIL; }
                if('FLG_FATTURE_MAIL' in dm ){ obj['FLG_FATTURE_MAIL'] = dm.FLG_FATTURE_MAIL; }
                if('operatore' in dm){ obj['NOME_OPERATORE'] = dm.operatore; }
                
                break;
            case 'sedelegaleutente':
                if('INDIRIZZO' in dm){ obj['INDIRIZZO'] = dm.INDIRIZZO; }
                if('NUM_CIVICO' in dm){ obj['NUM_CIVICO'] = dm.NUM_CIVICO; }
                if('CAP' in dm){ obj['CAP'] = dm.CAP; }
                if('COMUNE' in dm){ obj['COMUNE'] = dm.COMUNE; }
                if('PROVINCIA' in dm){ obj['PROVINCIA'] = dm.PROVINCIA; }
                if('operatore' in dm){ obj['NOME_OPERATORE'] = dm.operatore; }
                
                break;
            case 'segnalazioniee':
                obj['tipologia'] = 'E';
                if('segnalazione' in dm){ obj['SEGNALAZIONE'] = dm.segnalazione; }
                if('notesegnalazione' in dm){ obj['COMMENTI'] = dm.notesegnalazione; }
                if('POD' in dm){ obj['pod'] = dm.POD; }
                
                break;
            case 'segnalazionigas':
                obj['tipologia'] = 'G';
                if('segnalazione' in dm){ obj['SEGNALAZIONE'] = dm.segnalazione; }
                if('notesegnalazione' in dm){ obj['COMMENTI'] = dm.notesegnalazione; }
                if('POD' in dm){ obj['pod'] = dm.POD; }
                
                break;
            case 'privacy':
                if('FLG_GDPR_CONTRATTO' in dm ){ obj['FLG_GDPR_CONTRATTO'] = dm.FLG_GDPR_CONTRATTO; }
                if('FLG_GDPR_COMMERCIALE' in dm ){ obj['FLG_GDPR_COMMERCIALE'] = dm.FLG_GDPR_COMMERCIALE; }
                if('FLG_GDPR_POFILAZIONE' in dm ){ obj['FLG_GDPR_POFILAZIONE'] = dm.FLG_GDPR_POFILAZIONE; }
                if('FLG_GDPR_TERZE_PARTI' in dm ){ obj['FLG_GDPR_TERZE_PARTI'] = dm.FLG_GDPR_TERZE_PARTI; }
                break;
                
            default:
                break;
        }
        
        return obj;
    }
    
    
    gestisciRisultatoMail()
    {
        setTimeout( function(){
            var result = mail.leggiRisultatoMail();
            if( result === false )
            {
                console.log('Mail rilancio ricerca risultato');
                this.gestisciRisultatoMail();
            }
            else
            {
                console.log('Mail Gestisco risultato');
                if( result.success === true ){ this.closeDialog(); }
                else { this.setState( {messaggio: [<span className='erroreDialog'>Errore Invio Messaggio</span>] } ); }
            }
        }.bind(this),500 );
    }
    
    gestisciRisultatoAutoletture( count )
    {  
        count++;
        setTimeout( function(){

            var result = utils.leggiRisultatoAutoletture();
            if( count > 50)
            {
                this.setState( {messaggio: [<span className='erroreDialog'>Timeout della Richiesta</span>] } );
            }
            else if( result === false )
            {
                console.log('Autoletture rilancio ricerca risultato');
                this.gestisciRisultatoAutoletture(count);
            }
            else
            {
                console.log('Autoletture Gestisco risultato');
                if( result.success === true ){ 
                    this.setState( { mostraBottoniInvio:'nascosto', mostrasoloBottoneChiuso:'', messaggio: [<span className='erroreDialog'>Autolettura inserita Correttamente. Grazie</span>] } );
                    // setTimeout( function(){ this.closeDialog(); }.bind(this),3500 );
                }
                else {
                    if( 'message' in result && result.message !== ""){ this.setState( { mostraBottoniInvio:'', messaggio: [<span className='erroreDialog' dangerouslySetInnerHTML={{__html: result.message}}></span>] } ); }
                    else { this.setState( { mostraBottoniInvio:'', messaggio: [<span className='erroreDialog'>Errore Invio Autoletture</span>] } ); }
                }
            }
        }.bind(this),500 );
    }

    gestisciRisultatoPrivacy( count )
    {  
        count++;
        setTimeout( function(){

            var result = utils.leggiRisultatoPrivacy();
            if( count > 50)
            {
                this.setState( {messaggio: [<span className='erroreDialog'>Timeout della Richiesta</span>] } );
            }
            else if( result === false )
            {
                console.log('Privacy rilancio ricerca risultato');
                this.gestisciRisultatoPrivacy(count);
            }
            else
            {
                console.log('Privacy Gestisco risultato');
                if( result.success === true ){ 
                    window.location.reload();
                }
                else {
                    if( 'message' in result && result.message !== ""){ 
                        let msg = result.message;
                        msg=msg.replace(/\n/g, "<br />");
                        this.setState( {messaggio: [<span className='erroreDialog ms-fontSize-s' dangerouslySetInnerHTML={{__html: msg}}></span>] } );
                    }
                    else { this.setState( {messaggio: [<span className='erroreDialog ms-fontSize-s'>Errore Invio Privacy</span>] } ); }
                }
            }
        }.bind(this),500 );
    }    
    
    componentDidMount() {

        this.setState({tipo: this.props.tipo , bottoni: 'invia'});        
        console.log(this.props.tipo);
        
        switch( this.state.tipo ) {
            case 'indirizzofatturaee':
                this.setState({title: 'Indirizzo fatturazione E.E.' , tipo_operazione:'modificaSpedFatturaEE' , tipoAzioneInvio:'inviamail' });
                break;
            case 'indirizzofatturagas':
                this.setState({title: 'Indirizzo fatturazione Gas' , tipo_operazione:'modificaSpedFatturaGAS' , tipoAzioneInvio:'inviamail' });
                break;
            case 'sitoee':
                this.setState({title: 'Modifica Sito E.E.' , tipo_operazione:'modificaSitoEE' , tipoAzioneInvio:'inviamail' }); 
                break
            case 'sitogas':
                this.setState({title: 'Modifica Sito Gas' , tipo_operazione:'modificaSitoGAS' , tipoAzioneInvio:'inviamail' }); 
                break
            case 'avviso':
                this.setState({title: this.props.elemento.titolo ,bottoni: 'chiudi' , tipo_operazione:'' , tipoAzioneInvio:'' });
                break;
            case 'anagraficautente':
                this.setState({title: 'Anagrafica Utente' , tipo_operazione:'modificaAnagraficaCli' , tipoAzioneInvio:'inviamail' });
                break;
            case 'sedelegaleutente':
                this.setState({title: 'Sede Legale' , tipo_operazione:'modificaSedeLegaleCli' , tipoAzioneInvio:'inviamail' });
                break;
            case 'segnalazioniee':
                this.setState({title: 'Segnalazioni Energia Elettrica' , tipo_operazione:'Segnalazioni' , tipoAzioneInvio:'inviamail' });
                break;
            case 'segnalazionigas':
                this.setState({title: 'Segnalazioni Gas' , tipo_operazione:'Segnalazioni' , tipoAzioneInvio:'inviamail' });
                break;
            case 'autolettureee':
                this.setState({title: 'Autoletture Energia Elettrica' , tipo_operazione:'autoletturaEE' , tipoAzioneInvio:'autolettura' });
                break;
            case 'autoletturegas':
                this.setState({title: 'Autoletture Gas' , tipo_operazione:'autoletturaGAS' , tipoAzioneInvio:'autolettura' });
                break;
            case 'privacy':
                this.setState({title: 'Privacy' , tipo_operazione:'privacy' , tipoAzioneInvio:'privacy'   });
                break;
            case 'eliminaaccount':
                this.setState({title: 'Elimina Account' , bottoni:'elimina', tipo_operazione:'eliminaaccount' , tipoAzioneInvio:'eliminaaccount'   });
                break;
            case 'cancellapassword':
                this.setState({title: 'Elimina il tuo Account' , bottoni:'elimina', tipo_operazione:'cancellapassword' , tipoAzioneInvio:'cancellapassword'   });
                break;
                
            case 'noautoletture':
            case 'noautolettureDTD':
            case 'noautolettureultimigiorni':
                this.setState({title: 'Autoletture' , bottoni: 'chiudi' ,tipo_operazione:'' , tipoAzioneInvio:'' });
                break;
            default:
                break;
        }
        
        this.showDialog();
    }
    
    getcontent()
    {
        
        var ele = this.state.elemento;
        
        let vedi_terze_parti = utils.getInfoSocieta( 'VISUALIZZA_TERZE_PARTI_GDPR' , false );
        console.log( 'VISUALIZZA_TERZE_PARTI_GDPR' , vedi_terze_parti );
        
        if( this.state.tipo === 'privacy' )
        {
            
            // console.log(ele);
            this.setState({campiDaLeggere: ['FLG_GDPR_CONTRATTO','FLG_GDPR_COMMERCIALE','FLG_GDPR_POFILAZIONE','FLG_GDPR_TERZE_PARTI' ] , tipoAzione:'privacy'}); 
            this.setState({campiOriginali: {'FLG_GDPR_CONTRATTO':'', 'FLG_GDPR_COMMERCIALE':'', 'FLG_GDPR_POFILAZIONE':'', 'FLG_GDPR_TERZE_PARTI':''} });
            
            return(
                <div className='mediumsizebox editprivacy'>
                    <ChoiceGroup
                    className="defaultChoiceGroup"
                    defaultSelectedKey={ parseInt(ele.FLG_GDPR_CONTRATTO,10)===1 ? '1' : (parseInt(ele.FLG_GDPR_CONTRATTO,10)===0 ? '0' : '' )}
                    options={[ { key: '1', text: 'Si', id:'FLG_GDPR_CONTRATTO' }, { key: '0', text: 'No', id:'FLG_GDPR_CONTRATTO' } ]}
                    onChange={this._onChangeOption}
                    label={utils.getObjInfoSocieta( 'GDPR_CONTRATTO_DESC' , '' )}
                    required={false}
                />
                
                <ChoiceGroup
                    className="defaultChoiceGroup"
                    defaultSelectedKey={ parseInt(ele.FLG_GDPR_COMMERCIALE,10)===1 ? '1' : (parseInt(ele.FLG_GDPR_COMMERCIALE,10)===0 ? '0' : '' ) }
                    options={[ { key: '1', text: 'Si', id:'FLG_GDPR_COMMERCIALE' }, { key: '0', text: 'No', id:'FLG_GDPR_COMMERCIALE' } ]}
                    onChange={this._onChangeOption}
                    label={utils.getObjInfoSocieta( 'GDPR_COMMERCIALE_DESC' , '' )}
                    required={false}
                />
                
                <ChoiceGroup
                    className="defaultChoiceGroup"
                    defaultSelectedKey={ parseInt(ele.FLG_GDPR_POFILAZIONE,10)===1 ? '1' : (parseInt(ele.FLG_GDPR_POFILAZIONE,10)===0 ? '0' : '' )}
                    options={[ { key: '1', text: 'Si', id:'FLG_GDPR_POFILAZIONE' }, { key: '0', text: 'No', id:'FLG_GDPR_POFILAZIONE' } ]}
                    onChange={this._onChangeOption}
                    label={utils.getObjInfoSocieta( 'GDPR_POFILAZIONE_DESC' , '' )}
                    required={false}
                />
                
                
                <ChoiceGroup
                    className={ vedi_terze_parti ? 'defaultChoiceGroup' : 'defaultChoiceGroup nascosto' }
                    defaultSelectedKey={ parseInt(ele.FLG_GDPR_TERZE_PARTI,10)===1 ? '1' : (parseInt(ele.FLG_GDPR_TERZE_PARTI,10)===0 ? '0' : '' )}
                    options={[ { key: '1', text: 'Si', id:'FLG_GDPR_TERZE_PARTI' }, { key: '0', text: 'No', id:'FLG_GDPR_TERZE_PARTI' } ]}
                    onChange={this._onChangeOption}
                    label={utils.getObjInfoSocieta( 'GDPR_TERZE_PARTI_DESC' , '' )}
                    required={false}
                />
                
                <TextField  value={ parseInt(ele.FLG_GDPR_CONTRATTO,10)===1 ? '1' : (parseInt(ele.FLG_GDPR_CONTRATTO,10)===0 ? '0' : '' )}  id='FLG_GDPR_CONTRATTO' className='nascosto' />
                <TextField  value={ parseInt(ele.FLG_GDPR_COMMERCIALE,10)===1 ? '1' : (parseInt(ele.FLG_GDPR_COMMERCIALE,10)===0 ? '0' : '' ) }  id='FLG_GDPR_COMMERCIALE' className='nascosto' />
                <TextField  value={ parseInt(ele.FLG_GDPR_POFILAZIONE,10)===1 ? '1' : (parseInt(ele.FLG_GDPR_POFILAZIONE,10)===0 ? '0' : '' )}  id='FLG_GDPR_POFILAZIONE' className='nascosto' />
                <TextField  value={ parseInt(ele.FLG_GDPR_TERZE_PARTI,10)===1 ? '1' : (parseInt(ele.FLG_GDPR_TERZE_PARTI,10)===0 ? '0' : '' )}  id='FLG_GDPR_TERZE_PARTI' className='nascosto' />
            </div>
            );
        }
        
        
        if( this.state.tipo === 'indirizzofatturaee' || this.state.tipo === 'indirizzofatturagas' )
        {
            this.setState({campiDaLeggere: [ 'operatore','INDIRIZZO_SPEDIZIONE','COMUNE_SPEDIZIONE','CAP_SPEDIZIONE','PROVINCIA_SPEDIZIONE','COD_STUMENTO','CIVICO_SPEDIZIONE','COMMENTI_SPEDIZIONE' ] , tipoAzione:'INDIRIZZO_SPEDIZIONE' }); 
            this.setState({campiOriginali: { 
                    'INDIRIZZO_SPEDIZIONE':ele.INDIRIZZO_SPED , 'CIVICO_SPEDIZIONE':ele.NUM_CIVICO_SPED ,'COMUNE_SPEDIZIONE':ele.NOME_COMUNE_SPED,'CAP_SPEDIZIONE':ele.CAP_SPED,'PROVINCIA_SPEDIZIONE':ele.NOME_PROVINCIA_SPED
                }
            });
            
            let testo = 'POD : <b>'+ele.POD+'</b>';
            
            if( this.state.tipo === 'indirizzofatturagas'){
                let res = ele.POD.split("_");
                testo = 'REMI : <b>'+res[0]+'</b> - PDR : <b>'+res[1]+'</b>';
            }
       
            
            return(
            <div className='mediumsizebox'>
                <p><label dangerouslySetInnerHTML={{__html: testo}}></label></p>
                <TextField  className='nascosto' value={ele.chiave ? ele.chiave : ''} id='operatore'/>
                <TextField label='Indirizzo'  value={ele.INDIRIZZO_SPED ? ele.INDIRIZZO_SPED : ''} id='INDIRIZZO_SPEDIZIONE'/>
                <TextField label='Civico'  value={ele.NUM_CIVICO_SPED ? ele.NUM_CIVICO_SPED : ''} id='CIVICO_SPEDIZIONE' className='dueperriga'/>
                <TextField label='Comune' value={ele.NOME_COMUNE_SPED ? ele.NOME_COMUNE_SPED : ''}  id='COMUNE_SPEDIZIONE' className='dueperriga'/>
                <TextField label='CAP' value={ele.CAP_SPED ? ele.CAP_SPED : ''}  id='CAP_SPEDIZIONE' className='dueperriga'/>
                <TextField label='Provincia' value={ele.NOME_PROVINCIA_SPED ? ele.NOME_PROVINCIA_SPED : ''}  id='PROVINCIA_SPEDIZIONE' className='dueperriga'/>
                <TextField label='Commenti'  multiline rows={3} id='COMMENTI_SPEDIZIONE'/>
                
                <TextField value={ele.POD}  id='COD_STUMENTO' className='nascosto'/>
                <div></div>
            </div>
            );
        }
        
        if( this.state.tipo === 'sitoee' || this.state.tipo === 'sitogas' )
        {
            
            // console.log(this.state.elemento);
            this.setState({campiDaLeggere: [ 'operatore','DES_SITO','INDIRIZZO_SITO','COMUNE_SITO','CAP_SITO','PROVINCIA_SITO','COMMENTI_SITO','TIPO_RICHIESTA_SITO','MATRICOLA_GRUPPO_MISURA' ] , tipoAzione:'INDIRIZZO_SITO'}); 
            this.setState({campiOriginali: {
                    'DES_SITO':ele.DES_SITO,
                    'INDIRIZZO_SITO':ele.INDIRIZZO_SITO,
                    'COMUNE_SITO':ele.NOME_COMUNE,
                    'CAP_SITO':ele.CAP_SITO,
                    'PROVINCIA_SITO':ele.NOME_PROVINCIA,
                }
            });
            
            let testo = 'POD : <b>'+ele.POD+'</b>';
            
            if( this.state.tipo === 'sitogas'){
                let res = ele.POD.split("_");
                testo = 'REMI : <b>'+res[0]+'</b> - PDR : <b>'+res[1]+'</b>';
            }
            
            // gestione da MS381_AC2_CUSTOMIZATION
            let visualizzaDescSito = '';
            if( true === utils.getInfoSocieta( 'NASCONDI_CAMPI_MOD_SITO' , false ) ){
                visualizzaDescSito = 'nascosto'
            }
            
            return(
            <div className='mediumsizebox'>
                <p><label dangerouslySetInnerHTML={{__html: testo}}></label></p>
                <TextField  className='nascosto' value={ele.chiave ? ele.chiave : ''} id='operatore'/>
                <TextField label='DESC Sito' value={ele.DES_SITO ? ele.DES_SITO : ''}   multiline rows={3} id='DES_SITO' className={visualizzaDescSito} />
                <TextField label='Indirizzo Sito'  value={ele.INDIRIZZO_SITO ? ele.INDIRIZZO_SITO : ''} id='INDIRIZZO_SITO' className='dueperriga'/>
                <TextField label='Comune Sito' value={ele.NOME_COMUNE ? ele.NOME_COMUNE : ''}  id='COMUNE_SITO' className='dueperriga'/>
                <TextField label='CAP Sito' value={ele.CAP_SITO ? ele.CAP_SITO : ''}  id='CAP_SITO' className='dueperriga'/>
                <TextField label='Provincia Sito' value={ele.NOME_PROVINCIA ? ele.NOME_PROVINCIA : ''}  id='PROVINCIA_SITO' className='dueperriga'/>
                <TextField label='Commenti'  multiline rows={3} id='COMMENTI_SITO'/>
                <TextField label='Tipo di richiesta Sito' id='TIPO_RICHIESTA_SITO' className={visualizzaDescSito} />
                
                <TextField id='MATRICOLA_GRUPPO_MISURA' className='nascosto' value={ele.POD}/>
            </div>
            );
        }
        
        
        if( this.state.tipo === 'avviso' )
        {
            
            // console.log(this.state.elemento);
            this.setState({campiDaLeggere: []}); 
            
            return(
            <div className='mediumsizebox'>
                <label>{ele.testo}</label>
            </div>
            );
        }
        
        
        if( this.state.tipo === 'eliminaaccount' )
        {
            this.setState({campiDaLeggere: []}); 
            
            let testoDeleteAccount = utils.getObjInfoSocieta( 'MEX_DELETE_ACCOUNT' , "Stai Eliminando il tuo ACCOUNT dall'Area Clienti. Continuare?" );
            
            return(
            <div className='mediumsizebox'>
                <br/><label className={this.state.classErroreDeleteAccount} dangerouslySetInnerHTML={{__html: testoDeleteAccount}}></label>
            </div>
            );
        }
        
        if( this.state.tipo === 'cancellapassword' )
        {
            this.setState({campiDaLeggere: []}); 
            
            let testoDeleteAccount = utils.getObjInfoSocieta( 'MEX_DELETE_ACCOUNT' , "Stai Eliminando il tuo ACCOUNT dall'Area Clienti. Continuare?" );
            
            return(
            <div className='mediumsizebox'>
                <br/><label className={this.state.classErroreDeleteAccount} dangerouslySetInnerHTML={{__html: testoDeleteAccount}}></label>
            </div>
            );
        }
        
        if( this.state.tipo === 'anagraficautente' )
        {
            
            // console.log(ele);
            this.setState({campiDaLeggere: [ 'operatore','RAGIONE_SOCIALE','CODICE_FISCALE','PARTITA_IVA','CEL','FLG_FATTURE_MAIL','EMAIL' ] , tipoAzione:'ANAGRAFICA_UTENTE'}); 
            this.setState({campiOriginali: { 
                    'operatore':'',
                    'RAGIONE_SOCIALE': ele.RAGIONE_SOCIALE,
                    'CODICE_FISCALE': ele.CODICE_FISCALE,
                    'PARTITA_IVA': ele.PARTITA_IVA ,
                    'CEL': ele.CEL,
                    'FLG_FATTURE_MAIL': ele.FLG_FATTURE_MAIL ,
                    'EMAIL': ele.EMAIL 
                }
            });
            
            return(
            <div className='mediumsizebox'>
                <TextField  className='nascosto' value={ele.chiave ? ele.chiave : ''} id='operatore'/>
                <TextField label='Rag. Sociale' value={ele.RAGIONE_SOCIALE ? ele.RAGIONE_SOCIALE.replace(/(\\')/g , "'" ) : ''}   multiline rows={3} id='RAGIONE_SOCIALE' />
                <TextField label='Cod. Fiscale'  value={ele.CODICE_FISCALE ? ele.CODICE_FISCALE : ''} id='CODICE_FISCALE' className='dueperriga'/>
                <TextField label='P. Iva' value={ele.PARTITA_IVA ? ele.PARTITA_IVA : ''}  id='PARTITA_IVA' className='dueperriga'/>
                <TextField label='Cellulare (per servizio SMS)' value={ele.TEL ? ele.TEL : ''}  id='CEL' className='dueperriga'/>
                
                <ChoiceGroup
                    label='Adesione Servizio "SOLO Mail"'
                    defaultSelectedKey={(ele.FLG_FATTURE_MAIL===0 || ele.FLG_FATTURE_MAIL==='0') ? 'N' : 'S'} className='dueperriga'
                    options={[ { key: 'S', text: 'Si', id:'FLG_FATTURE_MAIL' }, { key: 'N', text: 'No', id:'FLG_FATTURE_MAIL' } ]}
                    onChange={this._onChangeOption}
                    required={false}
                  />
                <TextField label='Email' value={ele.EMAIL ? ele.EMAIL : ''}  multiline rows={3} id='EMAIL'/>
                        
                <TextField  value={(ele.FLG_FATTURE_MAIL===0|| ele.FLG_FATTURE_MAIL==='0') ? 'N' : 'S'}  id='FLG_FATTURE_MAIL' className='nascosto' />
            </div>
            );
        }
        
        if( this.state.tipo === 'sedelegaleutente' )
        {
            
            // console.log(this.state.elemento);
            this.setState({campiDaLeggere: [ 'operatore','INDIRIZZO','NUM_CIVICO','COMUNE','CAP','PROVINCIA' ] , tipoAzione:'SEDE_LEGALE'}); 
            this.setState({campiOriginali: { 
                    'operatore':'',
                    'INDIRIZZO':ele.INDIRIZZO,
                    'NUM_CIVICO':ele.NUM_CIVICO,
                    'COMUNE':ele.COMUNE,
                    'CAP':ele.CAP,
                    'PROVINCIA':ele.PROVINCIA
                }
            });
            
            
            return(
            <div className='mediumsizebox'>
                <TextField  className='nascosto' value={ele.chiave ? ele.chiave : ''} id='operatore'/>
                <TextField label='Indirizzo'  value={ele.INDIRIZZO ? ele.INDIRIZZO : ''} id='INDIRIZZO'/>
                <TextField label='Num. Civico'  value={ele.NUM_CIVICO ? ele.NUM_CIVICO : ''} id='NUM_CIVICO' className='dueperriga'/>
                <TextField label='Comune' value={ele.COMUNE ? ele.COMUNE : ''}  id='COMUNE' className='dueperriga'/>
                <TextField label='CAP' value={ele.CAP ? ele.CAP : ''}  id='CAP' className='dueperriga'/>
                <TextField label='Provincia' value={ele.PROVINCIA ? ele.PROVINCIA : ''}  id='PROVINCIA' className='dueperriga'/>
            </div>
            );
        }
        
        
        if( this.state.tipo === 'segnalazioniee' ||  this.state.tipo === 'segnalazionigas' )
        {
            this.setState({campiDaLeggere: [ 'POD','notesegnalazione','segnalazione' ] , tipoAzione:'??? da completare !!!'}); 
            
            var obj = '.';
            //if(this.state.tipo === 'segnalazioniee'){ obj = utils.getObjInfoSocieta( 'TIPO_SEGNALAZIONE_EE' , {} ); }
            //if(this.state.tipo === 'segnalazionigas'){  obj = utils.getObjInfoSocieta( 'TIPO_SEGNALAZIONE_GAS' , {} ); }
            
            if(this.state.tipo === 'segnalazioniee'){ obj = utils.getObjInfoSocieta( 'TIPO_SEGNALAZIONE_EE' , '.' ); }
            if(this.state.tipo === 'segnalazionigas'){  obj = utils.getObjInfoSocieta( 'TIPO_SEGNALAZIONE_GAS' , '.' ); }

            //var elenco = obj.NOTA_1.split("||");
            var elenco = obj.split("||");
            var options = [];
            
            for( var k=0; k< elenco.length ; k++)
            {
                var item = elenco[k].split('.');
                options.push({ key : item[0] , text: item[1] , id:'segnalazione'});
            }
            
            let testo = 'POD : <b>'+ele.POD+'</b>';
            
            if( this.state.tipo === 'segnalazionigas'){
                let res = ele.POD.split("_");
                testo = 'REMI : <b>'+res[0]+'</b> - PDR : <b>'+res[1]+'</b>';
            }
            
            
            return (
            <div className='mediumsizebox'>
    
                <p><label dangerouslySetInnerHTML={{__html: testo}}></label></p>
    
                <ComboBox label="Segnalazione" id="Basicdrop6" allowFreeform={false} onChanged={this._onChangeCombo} autoComplete="on" options={options}   />
                <TextField label='Note' value='' multiline rows={3} id='notesegnalazione' />
                        
                <TextField value='' id='segnalazione' className='nascosto' />
                <TextField value={ele.POD} id='POD' className='nascosto' />
            </div>
            );
        }
        
        
        if( this.state.tipo === 'noautoletture' )
        {
            
            let giorni = utils.getObjInfoSocieta( 'GIORNI_NO_AUTOLETTURA' , 'NO' );
            
            let testogiorni = 'gli ultimi '+giorni+' giorni';
            
            if( giorni === '1'){
                testogiorni = "l'ultimo giorno";
            }
            
            return (
                <div className='mediumsizebox'>
                    <h3>Autoletture Bloccate</h3>
                    <div>Non &egrave; possibile effettuare l'autolettura {testogiorni} del mese</div>
                </div>            
            );
        }
        
        if( this.state.tipo === 'noautolettureDTD' )
        {
            return (
                <div className='mediumsizebox'>
                    <h3>Autoletture Bloccate</h3>
                    <div>Non &egrave; possibile effettuare l'autolettura Fuori dai giorni prestabiliti</div>
                </div>            
            );
        }
        
        if( this.state.tipo === 'noautolettureultimigiorni' )
        {
            let giorni = utils.getObjInfoSocieta( 'ULTIMI_GIORNI_AUTOLETTURA' , 'NO' );
            
            let testogiorni = 'gli ultimi '+giorni+' giorni';
            
            if( giorni === '1'){
                testogiorni = "l'ultimo giorno";
            }
            
            return (
                <div className='mediumsizebox'>
                    <h3>Autoletture Bloccate</h3>
                    <div>&Egrave; possibile effettuare l'autolettura SOLO {testogiorni} del mese</div>
                </div>            
            );
        }
        
        
        if( this.state.tipo === 'autoletturegas' )
        {
            
            this.setState({campiDaLeggere: [ 'COD_STUMENTO','DATA_RIFERIMENTO','LETTURA_ATTUALE', 'MISURA_CORRETTORE', 'REMI', 'PDR' ] , campoDaAggiornare:'DATA_RIFERIMENTO' , tipoAzione:'AUTOLETTURA_GAS'} ); 
            
            let visualizzaCorrettore = 'nascosto';
            
            /*
            let pz = ele.POD.split('_');
            if( pz.length === 3 ){
                if( pz[2] !== '' ){ visualizzaCorrettore='';}
            }
            */
            
            if ( ele.MATRICOLA_CORRETTORE !== '' && ele.MATRICOLA_CORRETTORE !== null ){ visualizzaCorrettore=''; }
                
            
            let giorni = utils.getObjInfoSocieta( 'ULTIMI_GIORNI_AUTOLETTURA' , 'NO' );
            let dadataadata = utils.getObjInfoSocieta( 'AUTOLETTURA_DA_A' , '' );
            let firstDate = config.getToday();
            let lastDate = config.getToday();
            
            
            
            if( dadataadata !== false && dadataadata !== null && dadataadata !== 'null' && dadataadata !== '' && dadataadata.indexOf('-') === 0)
            {
                console.log("A - Autoletture GAS - AUTOLETTURA_DA_A configurata MALE" , dadataadata);
            }
            if( dadataadata !== false && dadataadata !== null && dadataadata !== 'null' && dadataadata !== '' && dadataadata.indexOf('-') === (dadataadata.length - 1) )
            {
                console.log("B - Autoletture GAS - AUTOLETTURA_DA_A configurata MALE" , dadataadata);
            }
            if( dadataadata !== false && dadataadata !== null && dadataadata !== 'null' && dadataadata !== '' && config.controllaErroriImpostazioniDate(dadataadata) === true)
            {
                console.log("C - Autoletture GAS - AUTOLETTURA_DA_A configurata MALE" , dadataadata);
            }
            // continuo
            
            if( dadataadata !== false && dadataadata !== null && dadataadata !== 'null' && config.controllaErroriImpostazioniDate(dadataadata) === false &&
                    dadataadata !== '' && dadataadata.indexOf('-') > 0 && dadataadata.indexOf('-') < (dadataadata.length -1) )
            {
                firstDate = config.getFirstDayByCode(dadataadata);
                lastDate = config.getLastDayByCode(dadataadata);
            }
            else
            if(giorni !== 'NO'){ 
                firstDate = config.getToday();
                lastDate = config.getLastDayMonth();
            } else { 
                firstDate = config.getLastYear();
                lastDate = config.getNextYear();
            }
            
            
            return (
                <div className='mediumsizebox'>
        
                    <h3>REMI : {ele.REMI} - PDR : {ele.PDR}</h3>
        
                    <DatePicker 
                        label='Data di riferimento'
                        firstDayOfWeek={firstDayOfWeek}
                        strings={DayPickerStrings}
                        placeholder="Seleziona una data"
                        dateFormat="DD-MM-YYYY"
                        formatDate={utils._onFormatDate}
                        locale='it'
                        value={new Date()}
                        onSelectDate={this._onSelectDate}
                        className='ms-font-m-plus'
                        disableAutoFocus='1'
                        minDate={firstDate}
                        maxDate={lastDate}
                     />
                     
                     <MaskedTextField label='Misura Contatore' value='' id='LETTURA_ATTUALE' maskChar='' mask={maskAutolettura} />
                     
                     <MaskedTextField label='Misura Correttore' value='' id='MISURA_CORRETTORE' maskChar='' mask={maskAutolettura} className={visualizzaCorrettore} />
                     
                     <TextField id='DATA_RIFERIMENTO' className='nascosto' value={utils._onFormatDate(new Date())} />
                     <TextField value={ele.POD} id='COD_STUMENTO' className='nascosto' />
                     <TextField value={ele.PDR} id='PDR' className='nascosto' />
                     <TextField value={ele.REMI} id='REMI' className='nascosto' />
                </div>            
            );
        }
        
        if( this.state.tipo === 'autolettureee' )
        {        
            // console.log( ele.TRATTAMENTO_TILP );
            
            // O -> orario --> nessuna autolettura
            // F --> fasce --> 3 Fasce x 3 ( attiva, reattiva, potenza)
            // M --> monofascia --> 1 fascia x 3 ??? 
            
            //if( ele.TRATTAMENTO_TILP === 'F' )  // http://10.11.2.51/issues/46619#note-9
            if( ele.TRATTAMENTO_TILP === 'F' || ele.TRATTAMENTO_TILP === 'O' || ele.TRATTAMENTO_TILP === 'ACEA' )
            {
            
                this.setState({campiDaLeggere: [ 'COD_STUMENTO','DATA_RIFERIMENTO','TILP','eaf1','eaf2','eaf3','erf1','erf2','erf3','pf1','pf2','pf3' ] , campoDaAggiornare:'DATA_RIFERIMENTO' , tipoAzione:'AUTOLETTURA_EE'} ); 

                let giorni = utils.getObjInfoSocieta( 'ULTIMI_GIORNI_AUTOLETTURA' , 'NO' );
                let dadataadata = utils.getObjInfoSocieta( 'AUTOLETTURA_DA_A' , '' );
                let firstDate = config.getToday();
                let lastDate = config.getToday();
                
                
                
                if( dadataadata !== false && dadataadata !== null && dadataadata !== 'null' && dadataadata !== '' && dadataadata.indexOf('-') === 0)
                {
                    console.log("A - Autoletture EE - AUTOLETTURA_DA_A configurata MALE" , dadataadata);
                }
                if( dadataadata !== false && dadataadata !== null && dadataadata !== 'null' && dadataadata !== '' && dadataadata.indexOf('-') === (dadataadata.length - 1) )
                {
                    console.log("B - Autoletture EE - AUTOLETTURA_DA_A configurata MALE" , dadataadata);
                }
                if( dadataadata !== false && dadataadata !== null && dadataadata !== 'null' && dadataadata !== '' && config.controllaErroriImpostazioniDate(dadataadata) === true)
                {
                    console.log("C - Autoletture EE - AUTOLETTURA_DA_A configurata MALE" , dadataadata);
                }
                // continuo

                if( dadataadata !== false && dadataadata !== null && dadataadata !== 'null' && config.controllaErroriImpostazioniDate(dadataadata) === false &&
                        dadataadata !== '' && dadataadata.indexOf('-') > 0 && dadataadata.indexOf('-') < (dadataadata.length -1) )
                {
                    firstDate = config.getFirstDayByCode(dadataadata);
                    lastDate = config.getLastDayByCode(dadataadata);
                }
                else
                if(giorni !== 'NO'){ 
                    firstDate = config.getToday();
                    lastDate = config.getLastDayMonth();
                } else { 
                    firstDate = config.getLastYear();
                    lastDate = config.getNextYear();
                }

                return (
                    <div className='mediumsizebox'>
            
                        <h3>POD : {ele.POD}</h3>

                        <DatePicker 
                            label='Data di riferimento'
                            firstDayOfWeek={firstDayOfWeek}
                            strings={DayPickerStrings}
                            placeholder="Seleziona una data"
                            dateFormat="DD-MM-YYYY"
                            formatDate={utils._onFormatDate}
                            locale='it'
                            value={new Date()}
                            onSelectDate={this._onSelectDate}
                            className='ms-font-m-plus'
                            disableAutoFocus='1'
                            minDate={firstDate}
                            maxDate={lastDate}
                         />

                         <div className="msGrid" id='elenchif1f2f3'>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm3">&nbsp;</div>
                                <div className="ms-Grid-col ms-sm3 elenchihead">Fascia 1</div>
                                <div className="ms-Grid-col ms-sm3 elenchihead">Fascia 2</div>
                                <div className="ms-Grid-col ms-sm3 elenchihead">Fascia 3</div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm3">Energia Attiva:</div>
                                <div className="ms-Grid-col ms-sm3"><MaskedTextField value='' id='eaf1' maskChar='' mask={maskAutolettura} className="ms-sm12"/></div>
                                <div className="ms-Grid-col ms-sm3"><MaskedTextField value='' id='eaf2' maskChar='' mask={maskAutolettura} className="ms-sm12"/></div>
                                <div className="ms-Grid-col ms-sm3"><MaskedTextField value='' id='eaf3' maskChar='' mask={maskAutolettura} className="ms-sm12"/></div>
                            </div>
                        </div>

                        <TextField id='DATA_RIFERIMENTO' className='nascosto' value={utils._onFormatDate(new Date())} />
                        <TextField value={ele.POD} id='COD_STUMENTO' className='nascosto' />
                        <TextField value={ele.TRATTAMENTO_TILP} id='TILP' className='nascosto' />
                    </div>            
                );
            }
            
            
            if( ele.TRATTAMENTO_TILP === 'M' )
            {
            
                this.setState({campiDaLeggere: [ 'COD_STUMENTO','DATA_RIFERIMENTO','TILP','eaf7','erf7','pf7' ] , campoDaAggiornare:'DATA_RIFERIMENTO' , tipoAzione:'AUTOLETTURA_EE'} );
                
                let giorni = utils.getObjInfoSocieta( 'ULTIMI_GIORNI_AUTOLETTURA' , 'NO' );
                let firstDate = config.getToday();
                let lastDate = config.getToday();
                if(giorni !== 'NO'){ 
                    firstDate = config.getToday();
                    lastDate = config.getLastDayMonth();
                } else { 
                    firstDate = config.getLastYear();
                    lastDate = config.getNextYear();
                }
                
                return (
                    <div className='mediumsizebox'>

                        <h3>POD : {ele.POD}</h3>

                        <DatePicker 
                            label='Data di riferimento'
                            firstDayOfWeek={firstDayOfWeek}
                            strings={DayPickerStrings}
                            placeholder="Seleziona una data"
                            dateFormat="DD-MM-YYYY"
                            formatDate={utils._onFormatDate}
                            locale='it'
                            value={new Date()}
                            onSelectDate={this._onSelectDate}
                            className='ms-font-m-plus'
                            disableAutoFocus='1'
                            minDate={firstDate}
                            maxDate={lastDate}
                         />

                         <div className="msGrid" id='elenchif1f2f3'>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm6">&nbsp;</div>
                                <div className="ms-Grid-col ms-sm6 elenchihead">Fascia Mono</div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm6">Energia Attiva:</div>
                                <div className="ms-Grid-col ms-sm6"><MaskedTextField value='' id='eaf7' maskChar='' mask={maskAutolettura}  className="ms-sm12"/></div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm6">Energia Reattiva:</div>
                                <div className="ms-Grid-col ms-sm6"><MaskedTextField value='' id='erf7' maskChar='' mask={maskAutolettura}  className="ms-sm12"/></div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm6">Potenza:</div>
                                <div className="ms-Grid-col ms-sm6"><MaskedTextField value='' id='pf7' maskChar='' mask={maskAutolettura}  className="ms-sm12"/></div>
                            </div>
                        </div>

                         <TextField id='DATA_RIFERIMENTO' className='nascosto' value={utils._onFormatDate(new Date())} />
                         <TextField value={ele.POD} id='COD_STUMENTO' className='nascosto' />
                         <TextField value={ele.TRATTAMENTO_TILP} id='TILP' className='nascosto' />
                    </div>            
                );
            }
            
            
            // if( ele.TRATTAMENTO_TILP !== 'M' && ele.TRATTAMENTO_TILP !== 'F' )  // http://10.11.2.51/issues/46619#note-9
            if( ele.TRATTAMENTO_TILP !== 'M' && ele.TRATTAMENTO_TILP !== 'F' && ele.TRATTAMENTO_TILP !== 'O' && ele.TRATTAMENTO_TILP !== 'ACEA' )
            {
            
                return( 
                    <div className="messaggioInDialog"><h3>POD : {ele.POD}</h3>Impossibile caricare l'autolettura, contattare il servizio clienti.</div>
                );
                
            }
            
        }
    }
    
    getBottoni(){
        
        if( this.state.bottoni === 'chiudi'){
            return(<PrimaryButton onClick={this.closeDialog} text="OK" />);
        }
        else if( this.state.bottoni === 'elimina'){
            /** Default ANNULLA e INVIA**/
            return(<span><DefaultButton onClick={this.closeDialog} text="Annulla" /><PrimaryButton onClick={this.inviaForm} text="Elimina" className='spaziosinistra'/></span>);
        }
        else
        {
            /** Default ANNULLA e INVIA**/
            return(<span><DefaultButton onClick={this.closeDialog} text="Annulla" /><PrimaryButton onClick={this.inviaForm} text="Invia" className='spaziosinistra'/></span>);
        }
    }
    
    
    render(){
        
        return (
        <Dialog
            hidden={!this.state.modalIsOpen}
            onDismiss={this.closeDialog}
            dialogContentProps={{
              type: DialogType.largeHeader ,
              title: this.state.title,
              subText: this.state.messaggio
            }}
            modalProps={{ isBlocking: false, className: 'ms-dialogMainOverride dialogPopup' }}
        >
            {this.state.testo}
            <DialogFooter className={this.state.mostraBottoniInvio}> {this.getBottoni()} </DialogFooter>
            <DialogFooter className={this.state.mostrasoloBottoneChiuso}><PrimaryButton onClick={this.closeDialog} text="CHIUDI" /></DialogFooter>
        </Dialog>
        );
   }
    
}

export default DialogBox;


// WEBPACK FOOTER //
// ./src/AcComponents/classi/DialogBox.js